import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";

const PAGE_TYPE = "Contact_us";

const QUERY_CONTACT_US = gql`
  query contact_us($uid: String!, $lang: String = "en-in") {
    ${PAGE_TYPE}: contact_us(uid: $uid, lang: $lang) {
      _linkType
      _meta {
        uid
        id
        type
      }
      title
      right_side_title
      enquiry_email
      enquiry_phone_number
      enquiry_working_hours
      service_description
      right_button_label
      button_link {
        _linkType
        ... on _ExternalLink {
          url
          target
        }
        ... on _Document {
          _meta {
            uid
            type
            id
          }
        }
      }
      ...Contact_usSEOFields
      ...Contact_usMetaFields
    }
  }
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
`;

export { PAGE_TYPE, QUERY_CONTACT_US };
